<div style="display: flex; flex-direction: column; justify-content: center">
	<h2 class="row-center title content-title" i18n="@@resetPassword-securityQuestionTitle">Security Question</h2>

	<p class="font-14 content-subtitle center" i18n="@@resetPassword-securityQuestionSubtitleNoBr">
		Further protect your account by choosing a security question from the options below.
	</p>

	<br />

	<p class="font-14 center blue" i18n="@@resetPassoword-selectQuestionLabel">Select Question and Confirm Answer</p>

	<form #myForm="ngForm" novalidate>
		<div class="column flex-gap">
			<mat-form-field subscriptSizing="dynamic" appearance="outline" style="padding: 0; margin: 0">
				<mat-label i18n="@@resetPassword-questionLabel">Question</mat-label>
				<mat-select required ngModel name="question" #question="ngModel" data-automation-id="security-question-picker">
					@for (question of questionsList; track question) {
						<mat-option
							class="list-option"
							[value]="question"
							[attr.data-automation-id]="'security-question-' + question"
						>
							{{ question }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<mat-form-field subscriptSizing="dynamic" appearance="outline" style="padding: 0; margin: 0">
				<mat-label i18n="@@resetPassword-answerLabel">Answer</mat-label>
				<input matInput required ngModel name="answer" #answer="ngModel" data-automation-id="answer-input" />
			</mat-form-field>
		</div>

		<br />

		<div class="button-spacing">
			<button
				mat-button
				class="secondary-button"
				i18n="@@registerUser-securityQuestionBack"
				(click)="onBackClicked()"
				data-automation-id="security-question-back-button"
			>
				Back
			</button>

			<button
				mat-button
				class="primary-button"
				i18n="@@registerUser-securityQuestionNext"
				[disabled]="!myForm.valid"
				(click)="onNextClicked(myForm)"
				data-automation-id="security-question-next-button"
			>
				Next
			</button>
		</div>
	</form>
</div>
